import React from 'react';
import PropTypes from 'prop-types';

import LanguageConverterV2 from '@careerstart/wae-common/src/main/helperFunction/LanguageConverterV2';
import CloseIcon from '@mui/icons-material/Close';
import Chip from '@mui/material/Chip';

import { PRIMARY_PURPLE } from '../../../theme/colorConstants';
import { PRIMARY_FONT } from '../../../theme/fontConstants';

const RequirementChip = ({ label, onDelete }) => {
  const removeLabel = LanguageConverterV2('positionTemplate.create.requirements.remove', {
    name: label,
  });

  return (
    <Chip
      label={label}
      onDelete={onDelete}
      deleteIcon={<CloseIcon aria-hidden={false} aria-label={removeLabel} role="button" />}
      data-testid="requirement-chip"
      sx={{
        backgroundColor: PRIMARY_PURPLE[20],
        border: `1px solid ${PRIMARY_PURPLE[30]}`,
        borderRadius: '999px',
        color: PRIMARY_PURPLE[80],
        fontFamily: PRIMARY_FONT[700],
        fontSize: '13px',
        height: '30px',
        '& .MuiChip-label': { padding: '0 10px 0 12px' },
        '& .MuiChip-deleteIcon': {
          color: PRIMARY_PURPLE[70],
          fontSize: '16px',
          margin: '0 8px 0 -4px',
          '&:hover': { color: PRIMARY_PURPLE[90] },
        },
      }}
    />
  );
};

RequirementChip.propTypes = {
  label: PropTypes.string.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default RequirementChip;
